import * as React from 'react';

import { createIcon } from '../Icon';
export const VideoIcon = createIcon(
  <React.Fragment>
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x={1} y={5} width={15} height={14} rx={2} ry={2} />
  </React.Fragment>,
  'VideoIcon'
);
